import { IncidentId } from '@collector/sportsapi-client-legacy'

import { injectAddIncidentConfig } from '../provide-inject'

// helper for repeated logic
function isIncidentInConfig(
  incidents: IncidentId[] | undefined,
  incidentId: IncidentId,
): boolean {
  if (!incidents) {
    return false
  }

  return incidents.includes(incidentId)
}

export function useAddIncidentConfig(): {
  isScoreIncident(incidentId: IncidentId): boolean
  isMissedIncident(incidentId: IncidentId): boolean
  isAttemptIncident(incidentId: IncidentId): boolean
  isStoppedIncident(incidentId: IncidentId): boolean
  isHighlightedIncident(incidentId: IncidentId): boolean
} {
  // inject
  const addIncidentConfig = injectAddIncidentConfig()

  // methods
  function isHighlightedIncident(incidentId: IncidentId): boolean {
    return isIncidentInConfig(
      addIncidentConfig?.highlightedIncidents,
      incidentId,
    )
  }

  function isScoreIncident(incidentId: IncidentId): boolean {
    return isIncidentInConfig(addIncidentConfig?.scoreIncidents, incidentId)
  }

  function isMissedIncident(incidentId: IncidentId): boolean {
    return isIncidentInConfig(addIncidentConfig?.missedIncidents, incidentId)
  }

  function isAttemptIncident(incidentId: IncidentId): boolean {
    return isIncidentInConfig(addIncidentConfig?.attemptIncidents, incidentId)
  }

  function isStoppedIncident(incidentId: IncidentId): boolean {
    return isIncidentInConfig(addIncidentConfig?.stoppedIncidents, incidentId)
  }

  return {
    isScoreIncident,
    isMissedIncident,
    isAttemptIncident,
    isStoppedIncident,
    isHighlightedIncident,
  }
}
